<template>
  <div v-loading="dataLoading">
    <div v-if="account.holderName" class="va-detail-top">
      <img class="icon-currency" :src="require(`@/assets/images/currency/${account.bizCurrency}.png`)"/>
      <div class="account-info">
        <p class="account-name">{{account.holderName}}</p>
        <p class="account-currency">{{account.bizCurrency}}</p>
      </div>
      <el-tag type="disabled" class="account-info-label">{{account.accountLabel}}</el-tag>
      <el-tag :type="getStatusType(account.vaStatus)">{{account.vaStatusText}}</el-tag>
    </div>
    <div class="va-detail-content">
      <div class="va-detail-content-box" :style="{minHeight: `${boxHeight}px`}">
        <div class="form-wrapper">
          <div class="va-form-title">{{$t('message.collection.accountInfo')}}</div>
          <el-form label-position="top">
            <el-form-item v-for="(item, index) in accountInfo" :key="index" :label="item.isInternationalization ? $t(item.label) : item.label">
              <div class="va-form-item">
                <span>{{item.value}}</span>
                <span class="icon-copy-box" @click="handleCopy(item.value)"><i class="iconfont icon-copy"></i></span>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="va-detail-content-box" :style="{minHeight: `${boxHeight}px`}">
        <div class="form-wrapper">
          <div class="va-form-title">{{$t('message.collection.accountFunction')}}</div>
          <el-form label-position="top">
            <el-form-item>
              <div class="account-func">
                <div v-for="(item, index) in tipList" :key="index" class="account-func-item">
                  <div class="account-func-item-title">
                    <i class="item-icon el-icon-circle-check"></i>
                    <span>{{item.functionTips}}</span>
                  </div>
                  <div class="account-func-item-desc">{{item.timeTips}}</div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="table-wrapper">
      <div class="table-title">{{$t('message.transaction.info')}}</div>
      <custom-table :table-set="tableCondition"
                    ref="table"
                    :is-first-automatic-visit="false"
                    :is-pagination-display="false"
                    :service-function="queryVaTransactionList">
      </custom-table>
    </div>
  </div>
</template>

<script>
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import CustomTable from '@/components/table/custom-table.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import VaTransactionService from '@/views/collection/api/transaction';
import { getVADetail } from '@/views/collection/api/va.js';

export default {
  components: {
    CustomTable,
  },
  data() {
    return {
      dataLoading: false,
      account: {},
      accountInfo: [],
      tipList: [],
      tableCondition: [
        { // 交易日期
          titleBar: { type: 'text', title: 'message.tableCommon.txnTime' },
          key: 'createTime',
          type: 'text',
        },
        { // 交易号
          titleBar: { type: 'text', title: 'message.tableCommon.txnSerialNumber' },
          key: 'id',
          type: 'text',
        },
        { // 交易类型
          titleBar: { type: 'text', title: 'message.collection.type' },
          key: 'bizType',
          type: 'text',
          textFunc: (row) => {
            return getEnantiomericValue(this.bizTypeList, row.bizType);
          },
        },
        { // 金额
          titleBar: { type: 'text', title: 'message.index.amount' },
          key: 'payinAmount',
          type: 'text',
          textFunc: (row) => {
            return `${row.payinAmount} ${row.payinCurrency}`;
          },
        },
        { // 费用
          titleBar: { type: 'text', title: 'message.settlement.serviceAmount' },
          key: 'payinFee',
          type: 'text',
          textFunc: (row) => {
            return `${row.payinFee} ${row.payinCurrency}`;
          },
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'txnStatus',
          type: 'tag',
          textFunc: (row) => {
            return getEnantiomericValue(this.merPayinStatusList, row.txnStatus);
          },
          tagTypeFunc: (row) => {
            if (row.txnStatus === 'Settled') {
              return 'success';
            } else if (row.txnStatus === 'Rejected') {
              return 'danger';
            } else {
              return 'info';
            }
          },
        },
        { // 操作
          titleBar: { type: 'operations', title: 'message.tableCommon.status' },
          key: 'operations',
          type: 'operations',
          subTableDisplays: [
            {
              type: 'text_button',
              textFunc: () => 'message.tableCommon.see',
              // permissionCode: 'collection:transaction:view',
              func: (data) => {
                this.$router.push({
                  path: '/collection/transaction/view',
                  query: { id: data.id },
                });
              },
            },
          ],
        },
      ],
      merPayinStatusList: [],
      bizTypeList: [],
      boxHeight: 480,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      const { vaId } = this.$route.query;
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['MER_PAYIN_STATUS', 'VA_BIZ_TYPE', 'VA_STATUS']);
        this.bizTypeList = initSelectedData(dict.VA_BIZ_TYPE);
        this.merPayinStatusList = initSelectedData(dict.MER_PAYIN_STATUS);
        const statusList = initSelectedData(dict.VA_STATUS);
        const res = await getVADetail({ id: vaId });
        this.account = {
          holderName: res.holderName,
          bizCurrency: res.bizCurrency,
          vaStatus: res.vaStatus,
          vaStatusText: getEnantiomericValue(statusList, res.vaStatus),
          accountLabel: res.accountLabel,
        };
        this.accountInfo = res.infoList || [];
        this.tipList = res.tipList || [];

        this.boxHeight = this.accountInfo.length * 85 + 55;

        this.$refs.table.firstVisitHttp();
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    async handleCopy(data) {
      await this.$copyText(data);
      ShowSuccessMessage(this.$t('message.common.copySuccess'));
    },
    queryVaTransactionList() {
      const params = { size: 3, accountLabel: this.account.accountLabel };
      return VaTransactionService.getVaTransactionList(params);
    },
    getStatusType(status) {
      if (status === '4') { // 已激活
        return 'success';
      } else if (status === '0') { // 初始化
        return 'danger';
      } else if (status === '2') { // 冻结
        return 'disabled';
      } else {
        return 'info';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.va-detail-top {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  padding-top: 4px;
  padding-bottom: 23px;
  border-bottom: 1px solid rgba(0,32,63,0.08);

  .icon-currency {
    width: 40px;
    height: 40px;
  }

  .account-info {
    margin-left: 22px;
    margin-right: 40px;

    .account-name {
      font-size: 18px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-primary;
      line-height: 32px;
    }

    .account-currency {
      font-size: 14px;
      font-weight: bold;
      color: #00203F;
      line-height: 32px;
    }
  }

  .account-info-label {
    margin-right: 20px;
  }
}

.va-detail-content {
  display: flex;
  // height: 200px;
  min-height: 480px;

  .va-detail-content-box {
    height: 100%;
    flex: 1;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.05);
    border-radius: 2px;
    flex-shrink: 0;
    width: 50%;

    &:first-child {
      margin-right: 40px;
    }

    .va-form-title {
      font-size: 16px;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      color: $color-text-primary;
      line-height: 25px;
      margin-bottom: 10px;
    }

    .form-wrapper {
      margin: 20px;

      .va-form-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-family: Avenir-Book, Avenir;
        font-weight: normal;
        color: $color-text-primary;
        line-height: 32px;

        .icon-copy-box {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 33px;
          height: 33px;
          border-radius: 4px;
          font-size: 20px;
          font-weight: 800;
          color: $color-success;
          cursor: pointer;

          &:hover {
            background: #F1F5F7;
          }
        }
      }

      .account-func {
        background: #F1F5F7;
        border-radius: 4px;
        padding: 20px;
        padding-top: 15px;

        .account-func-item {
          margin-bottom: 5px;
          word-break: break-all;
          .account-func-item-title {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: Avenir-Heavy, Avenir;
            font-weight: 800;
            color: $color-text-primary;
            line-height: 32px;

            .item-icon {
              // width: 17px;
              // height: 17px;
              font-size: 17px;
              margin-right: 10px;
              font-weight: 800;
              color: $color-success;
            }
          }

          .account-func-item-desc {
            margin-left: 27px;
            font-size: 14px;
            font-weight: 400;
            color: $color-text-primary;
            line-height: 18px;
          }
        }
      }
    }
  }
}

.table-wrapper {
  margin-top: 40px;

  .table-title {
    font-size: 26px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 36px;
    padding-left: 12px;
  }
}

</style>
